import { styled } from '@mui/material';

import AcadlyTypography from '../../../../../../components/Typography';

export const Heading = styled((props) => <AcadlyTypography variant="h4Medium" {...props} />)(
  () => ({})
) as typeof AcadlyTypography;
